import { useState } from "react";
import {
  CloseOutlined,
  ContentCopyOutlined,
  EditOutlined,
} from "@mui/icons-material";
import { IconButton, Stack, Tooltip, Typography } from "@mui/material";
import { toast } from "react-toastify";
import EditDistributionListPopup from "./EditDistributionListPopup";
import DeleteDistributionUser from "./DeleteDistributionUser";
import { useDistributionLists } from "../hooks";

export default function DistributionListItem({ distList, ...props }) {
  const [editOpen, setEditOpen] = useState(false);
  const [deleteOpen, setDeleteOpen] = useState(false);
  const [copied, setCopied] = useState(false);
  const { deleteDistributionList, loading } = useDistributionLists();

  const handleEdit = () => {
    setEditOpen(true);
  };

  const handleDelete = () => {
    setDeleteOpen(true);
  };

  const confirmDelete = async () => {
    try {
      await deleteDistributionList(distList.id);
      setDeleteOpen(false);
    } catch (error) {
      console.error("Failed to delete distribution list:", error);
    }
  };

  return (
    <>
      <Stack
        component="li"
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        gap={0.75}
        maxWidth="100%"
        width={{ xs: "100%", sm: "70%", md: "50%" }}
        {...props}
      > 
          <IconButton size="small" onClick={handleEdit} edge="start">
            <EditOutlined fontSize="inherit" />
          </IconButton>
        
        <Tooltip title={distList.name}>
          <Typography noWrap component="div" sx={{ flex: 1, minWidth: 0, overflow: 'hidden', textOverflow: 'ellipsis' }}>
            {distList.name}
          </Typography>
        </Tooltip>
        
        <Tooltip title={`@${distList.slug}`}>
          <Typography component="div" noWrap sx={{ flex: 1, minWidth: 0, overflow: 'hidden', textOverflow: 'ellipsis' }}>
            {distList.slug}
          </Typography>
        </Tooltip>
        
          <IconButton 
            size="small" 
            onClick={handleDelete} 
            edge="end"
            disabled={loading}
          >
            <CloseOutlined fontSize="inherit" />
          </IconButton>
      </Stack>

      <EditDistributionListPopup
        open={editOpen}
        onClose={() => setEditOpen(false)}
        distributionList={distList}
      />

      <DeleteDistributionUser
        open={deleteOpen}
        onClose={() => setDeleteOpen(false)}
        onConfirm={confirmDelete}
        user={{ name: distList.name, email: distList.slug }}
        loading={loading}
        isDistributionList={true}
      />
    </>
  );
}
